import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 7l4 -4l4 4","key":"svg-0"}],["path",{"d":"M8 17l4 4l4 -4","key":"svg-1"}],["path",{"d":"M12 3l0 18","key":"svg-2"}]]

/**
 * IconArrowsVertical
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLXZlcnRpY2FsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik04IDdsNCAtNGw0IDQiIC8+CiAgPHBhdGggZD0iTTggMTdsNCA0bDQgLTQiIC8+CiAgPHBhdGggZD0iTTEyIDNsMCAxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrows-vertical
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsVertical = createReactComponent('outline', 'arrows-vertical', 'ArrowsVertical', __iconNode);

export default IconArrowsVertical;